<template>
  <div>
    <div :class="className +' d-none d-lg-block'">
      <ins class="adsbygoogle"
           style="display:block"
           data-ad-client="ca-pub-1494651695816916"
           data-ad-slot="6953063760"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    timeout: Number,
    className: String,
    slotter: String
  },
  data() {
    return {
      googleInit: null,
      googleAdId: 'ca-pub-1494651695816916'
    }
  },

  mounted() {

    if (typeof window !== 'undefined')
      (window.adsbygoogle = window.adsbygoogle || []).push({})

  },
  destroyed() {
    if (this.googleInit) clearTimeout(this.googleInit)
  }

}
</script>

<style>
.ad-border {
  padding: 10px;
  border: 1px solid #eee;
}

.ad-noborder {
  padding: 10px;
}
</style>